// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { VERSION } from './version';

export const environment = {
  // General Settings
  production: false,
  title: 'Dev Environment',
  version: VERSION,

  // Seacom API Settings
  apiURL: 'server/api/v1/',
  apiTimeout: 10000,
  apiCacheTime: 300000,

  // Weather API Settings
  weatherApiURL: 'https://api.weatherapi.com/v1/forecast.json',
  weatherApiKey: '588add4d55ce428d87013451221902',
  weatherApiTimeout: 10000,
  weatherApiCacheTime: 900000,

  // Google Maps settings
  googleMapsKey: 'AIzaSyA-wjKFhT8_T04PwfEeefvO2D-fgVjEqVU',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
